
export default class CardProcessResponseModel {
    isSuccessful : boolean = false;
    message : string = ""    


    static from(json: string): CardProcessResponseModel {
        let model = Object.assign(new CardProcessResponseModel(), json);
        return model;
    }
}